var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center"},[_c('b-spinner',{staticStyle:{"width":"5rem","height":"5rem","background-color":"#EC5500"},attrs:{"variant":"primary","type":"grow","label":"Spinning"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }